import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as apiCompany from "../../../../api/apiCompany"
import * as Auth from "../../../Login/Auth"
import { Pagination } from '../../Res/Pagination';
import { EnableBadge, DisableBadge, AddButton } from '../../Res/BaseButton';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { ContentBox } from '../ContentBox';

export function CompanyList({setIsLoading}) {
  const [companyList, setCompanyList] = useState([])
  const [page, setPage] = useState(1)
  const [limit] = useState(10)
  const [count, setCount] = useState(0)
  const [enableCount, setEnableCount] = useState(0)
  const [disableCount, setDisableCount] = useState(0)

  function toAdd() {
    window.location.assign("/CompanyAdd");
  }

  useEffect(() => {
    if (companyList.length === 0)
      getCompanyList()
  }, [])

  function getCompanyList() {
    setIsLoading(true)
    console.log("getManagerList")
    console.log("page : " + page)
    var start = (page - 1) * limit;
    apiCompany.getCompanyList({/*, start, limit,*/
      success: (jsonData) => {
        if (jsonData.status) {
          console.log("page : " + page)
          setCompanyList(jsonData.list)
          setCount(jsonData.count)
          setEnableCount(jsonData.enableCount)
          setDisableCount(jsonData.disableCount)
          console.log("page : " + page)
          setIsLoading(false)
        } else {
          setIsLoading(false)
          Swal.fire({
            type: 'error',
            title: '提醒',
            text: '發生錯誤, 請洽詢技術人員',
          }).then(function () {
          })
        }
      },
      failure: (err) => {

      }
    })
  }

  var title = '公司列表'
  var content =
    <>
      <div className="row">
        <div className="col-sm-12">
          <EnableBadge count={enableCount} />
          <DisableBadge count={disableCount} />
          <AddButton name={"新增"} action={toAdd} />
        </div>
      </div>
      <div className="row m-b-sm">
      </div>
      <CompanyListBox companyList={companyList} scl={setCompanyList} count={count} page={page} sp={setPage} />
    </>

  return (
    <>
      <ContentBox title={title} content={content} hasDrawer={true} />
      <SystemPromptInput />
    </>

  )
}


function CompanyListBox({ companyList, scl, count, page, sp }) {
  const [mCompanyList, setCompanyList] = useState([])
  const [mPage, setPage] = useState(1)
  const [limit] = useState(10)
  const [mCount, setCount] = useState(0)


  function sPage(p) {
    setPage(p)
  }

  useEffect(() => {
    if (companyList !== undefined && companyList !== mCompanyList) {
      setCompanyList(companyList)
    }
    if (count !== mCount) {
      setCount(count)
    }
  }, [companyList])



  if (companyList.length === 0) {
    return (<></>)
  } else {
    //console.log(managerList)
    return (
      <>
        <div id="editable_wrapper" className="form-inline dt-bootstrap">
          <div className="row">
            <div className="col-sm-12">
              <table className="table table-striped table-bordered table-hover  dataTable">
                <thead>
                  <tr role="row">
                    <th className="text-center sorting col-sm-4">名稱</th>
                    <th className="text-center sorting col-sm-4">員工數</th>
                    <th className="text-center sorting col-sm-4">狀態</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    mCompanyList.map((company) => (
                      <CompanyBox key={company.companyId} manager={company} />
                    ))
                  }
                </tbody>
              </table>
            </div>
          </div>
          {
            mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} />
          }
        </div>
      </>
    )
  }

}

function CompanyBox({ manager }) {
  const [company, setAccount] = useState(manager)
  if (company !== manager) {
    setAccount(manager)
  }
  var status = "<></>";
  if (company.isDisable === 1) {
    status = <span className="text-danger">停用</span>
  } else {
    status = <span className="text-info">啟用</span>
  }
  function toDetail() {
    window.location.replace("/CompanyDetail/"+company.companyId);
  }

  return (
    <tr>
    <td className="text-center"><a href="#A" onClick={e=>toDetail()} >{company.companyName}</a></td>
    <td className="text-center"> - </td>
    <td className="text-center"> <span className="text-info">{status}</span></td>
    {/**
      <td style={{ verticalAlign: "middle" }}><div>{company.companyName}</div></td>
      <td style={{ verticalAlign: "middle" }}>{company.texIdNumber}</td>
      <td style={{ verticalAlign: "middle" }}>{company.businessArea}</td>
      <td style={{ verticalAlign: "middle" }}></td>
      <td style={{ verticalAlign: "middle" }}>{status}</td>
      <td style={{ verticalAlign: "middle" }}>{company.note}</td>
     */}
    </tr>
  )
}